import React, {useState, useEffect} from 'react'
import './Posts.css';
import Card from '../Card/Card'
import {useSelector} from 'react-redux';
import {CircularProgress} from '@mui/material';
// import Button from '@mui/material/Button';
import Snackbar from '@mui/material/Snackbar';
import IconButton from '@mui/material/IconButton';
import CloseIcon from '@mui/icons-material/Close';

const Posts = ({setCurrentId}) =>  {
  const [user, setUser] = useState(JSON.parse(localStorage.getItem('profile')));

  const posts = useSelector((state) => state.posts);
  const [sort, setSort] = useState(false);
  const [sortedPosts, setSortedPosts] = useState([]);
  const [myPosts, setMyPosts] = useState(false)
  const [StoreMyPosts, setStoreMyPosts] = useState([]);
  // const [tapped, setTapped] = useState('close');

  const [open, setOpen] = useState(false);

  

  const handleClose = (event, reason) => {
    if (reason === 'clickaway') {
      return;
    }

    setOpen(false);
  };
    const handleClick = () => {
      if(sort)
      {
        setSort(false);
      }
      else if(myPosts)
      {
        setMyPosts(false);
      }
    }

  const handleSort = () => {
    if(myPosts)
    {
      setMyPosts(false);
    }
    setSort((prevSort) => !prevSort);
    //open the snackbar
    setOpen(true);
  }

  const fetchMyPosts = () => {
    if(sort)
    {
      setSort(false);
    }
    setMyPosts((prevState) => !prevState);
  }
  useEffect(()=>{
    if(sort)
    {
      const sorted = posts.slice().sort((a, b) => {
        const dateA = new Date(a.createdAt);
        const dateB = new Date(b.createdAt);
        return dateB - dateA;
      });
      // console.log(sorted);
      setSortedPosts(sorted);
    }
    //when you have to pick some elements from the array then use the filter method...
    //const getMyPosts = posts.filter(post => ppost.creator === user.result.googleId || post.creator === user.result._id) 
    else if(myPosts)
    {
      const getMyPosts = posts.filter(post => post.creator === user.result.googleId || post.creator === user.result._id);
      // console.log(getMyPosts);
      setStoreMyPosts(getMyPosts);
    }
    
  },[posts, sort, myPosts]);

  const action = (
    <React.Fragment>
      
      <IconButton
        size="small"
        aria-label="close"
        color="inherit"
        onClick={handleClose}
      >
        <CloseIcon fontSize="small" />
      </IconButton>
    </React.Fragment>
  );
  

  
  return (
    

    !posts.length ? <CircularProgress/> : (
      <>
      <div className='cardGrid'>
      <div>
        <h3 className='headline' onClick={handleClick}>Latest Topics</h3>
        <button className='Sort' onClick={handleSort}>Sort Posts</button>
        {!sort && !myPosts && <div className='Under'></div>}
        {sort && <div className='UnderSort'></div>}
        {
          user && <button className='myPosts' onClick={fetchMyPosts}>My Posts</button>
        }
        
        {myPosts && <div className='UnderMyPosts'></div>}
      </div>
      
      <div className="Cards">
            {/* {
            // posts.map((post) => (
              
            //   <Card post={post} setCurrentId = {setCurrentId}/>
              
            // ))
            sort ? (posts.sort((a, b) => new Date(b.timestamp) - new Date(a.timestamp))
              .map((post) => (
                <Card post={post} setCurrentId={setCurrentId} />
              ))) : 
               posts.map((post) => (
              
              <Card post={post} setCurrentId = {setCurrentId}/>
              
            ))
            } */}

{
  sort &&
  sortedPosts.map((post) => (
    <Card post = {post} setCurrentId={setCurrentId}/>
  ))
}
{
  myPosts &&
  StoreMyPosts.map((post) => (
    <Card post = {post} setCurrentId={setCurrentId}/>
  ))
}
{
  !sort && !myPosts &&
  posts.map((post) => (
    <Card post = {post} setCurrentId={setCurrentId}/>
  ))
} 



       </div> 
      
    </div>
    <div>
      
      <Snackbar
        open={open}
        autoHideDuration={6000}
        onClose={handleClose}
        message="Sorted : Newest First"
        action={action}
      />
    </div>
    </>
    )
    
    
  )
}

export default Posts
